import logger from '@/utils/logger';
import fetchService from '@/utils/model/fetch_service';
import {
  filterUnique,
  showToast,
  isObject,
  isString,
} from '@/utils/tools';

import globals from '@/globals';

/* ##### LOCAL ######## */

// FIXME: this should be removed once we make the panel component
function openClosedUILayout() {
  const el = document.querySelector('.ui-layout-toggler');
  if (el && el.classList.contains('ui-layout-toggler-closed')) {
    el.click();
  }
}

/* ##### EXPORTED ##### */

// REALMS
function fetchRealms(context) {
  return fetchService
    .GetData('realms_list')
    .then((data) => {
      context.commit('replaceRealms', data.data);
      return data;
    });
}

async function addRealm(context, payload) {
  const name = payload.input.trim();
  const data = await fetchService.GetData('realms_create', { name });

  if (data.error) {
    showToast(data.message, 1);
    return false;
  }

  context.commit('addRealm', data.data);
  context.commit('resetRealmFocus');

  return true;
}

/**
 * Initiates the Realm deletion process
 * @param {object} context
 * @param {string} payload
 * @returns {string}
 */
async function deleteRealm(context, payload) {
  const params = { '@path': String(payload.name) };
  const data = await fetchService.GetData('realms_delete', params);

  showToast(data.message, data.error);

  if (data.error) {
    return false;
  }

  context.commit('removeRealm', payload.name);
  context.commit('resetRealmFocus');
  return true;
}

// TAGS
function fetchRealmTags(context, payload) {
  return new Promise((resolve) => {
    if (payload) {
      const { name } = payload;
      const props = { '@path': `${name}` };

      fetchService
        .GetData('realms_realm', props)
        .then((data) => {
          context.commit('replaceRealmTags', { tags: data.data, name });
          resolve(Array.isArray(data.data));
        });
    } else {
      resolve(false);
    }
  });
}

async function addRealmTag(context, payload) {
  const { state } = context;
  const { focusedRealm } = state;
  const { entries } = payload;
  const realm = state.realms[focusedRealm];

  const trimmed = payload.input.trim();

  if (!realm && !entries.length) return false;

  // Make sure all entries are unique
  // Also use the input, if a when gathering the list
  const filtered = trimmed
    ? filterUnique(entries, trimmed)
    : filterUnique(entries);

  const params = {
    name: realm.name,
    tags: filtered,
  };

  const data = await fetchService.GetData('tag_create', params);

  if (data.error) {
    showToast(data.message, 1);
    return false;
  }

  context.commit('addTagItems', {
    realm,
    items: data.data,
  });
  return true;
}
async function deleteRealmTag(context, payload) {
  // if (!payload.confirmed) {
  //   return openTagConfirmation(context, payload, false);
  // }

  const realm = encodeURIComponent(String(context.state.focusedRealm));
  const tag = encodeURIComponent(String(payload.name));
  // const realm = context.state.focusedRealm;
  // const tag = payload.name;
  const params = {
    '@path': `${realm}/${tag}`,
  };
  const data = await fetchService.GetData('tag_delete', params);

  showToast(data.message, data.error);

  if (data.error) {
    return false;
  }

  context.commit('removeTagItem', { tag: decodeURIComponent(tag), realm });

  const realmTags = context.state.realms[realm].tags;

  if (realmTags.length <= 0) {
    context.commit('removeRealm', realm);
  }

  return true;
}

function showRealTagInDocBrowser(context, payload) {
  try {
    const realm = encodeURIComponent(String(context.state.focusedRealm));
    const tag = encodeURIComponent(String(payload.name));

    if (!isString(realm, true) || !isString(tag, true)) return false;

    const uri = globals.I.Util.uri('/document/browser', `filter=${realm} IN ("${tag}")`);
    globals.context.open(uri, '_blank');
    return true;
  } catch (err) {
    logger.warn(err);
    return false;
  }
}

async function toggleRealmTagRecommendation(context, payload) {
  if (isObject(payload)) {
    const realm = encodeURIComponent(String(context.state.focusedRealm));
    const { recommended } = payload;
    const name = encodeURIComponent(payload.name);
    const params = {
      '@path': `${realm}/${name}`,
      recommended: recommended ? 0 : 1,
    };

    const data = await fetchService.GetData('tag_recommend', params);

    if (data.error) {
      showToast(data.message, 1);
      return false;
    }

    context.commit('updateTagItem', data.data);

    const toastKey = recommended
      ? 'tagRemovedRecommendedMsg'
      : 'tagAddedRecommendedMsg';

    showToast(context.rootState.LANG[toastKey]);

    return true;
  }

  return false;
}

// UI ACTIONS
async function focusRealm(context, payload) {
  const { state } = context;
  const exists = state.realms[payload.name].tags;

  openClosedUILayout();

  if (!exists) {
    state.listLoading = true;
    await context.dispatch('fetchRealmTags', payload);
    state.listLoading = false;
  }

  context.commit('setRealmFocus', payload);
}

export default {
  // REALMS
  addRealm,
  deleteRealm,

  // TAGS
  addRealmTag,
  deleteRealmTag,
  showRealTagInDocBrowser,
  toggleRealmTagRecommendation,

  // Data
  fetchRealms,
  fetchRealmTags,

  // UI
  focusRealm,
};
